import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

@Pipe({
    name: 'safe',
    standalone: false
})
export class SafePipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  public transform(url: string, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(url);
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(url);
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(url);
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(url);
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}
